import { StatusBar } from 'expo-status-bar';
import { useColorScheme } from 'react-native';

import { useAppearance } from '@/lib/appearance';

/**
 * Drives the status-bar icon color from the resolved appearance. The theme is
 * Uniwind-driven and decoupled from the OS scheme, so `style="auto"` can't be
 * trusted — we resolve "system" via the OS scheme ourselves. On a dark canvas
 * we want light icons, and vice versa.
 */
export function AppStatusBar() {
  const { appearance } = useAppearance();
  const systemScheme = useColorScheme();
  const resolved = appearance === 'system' ? (systemScheme ?? 'light') : appearance;

  return <StatusBar style={resolved === 'dark' ? 'light' : 'dark'} />;
}
